/*
 * <price-range-slider> — dual-handle price slider that drives Dawn's existing
 * text inputs. Auto-runs on every DOM insert (including AJAX facet swaps).
 */
(function () {
  if (customElements.get('price-range-slider')) return;

  class PriceRangeSlider extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.rangeMax = parseFloat(this.dataset.rangeMax) || 0;
      this.minThumb = this.querySelector('.facets__price-thumb--min');
      this.maxThumb = this.querySelector('.facets__price-thumb--max');
      this.fill = this.querySelector('.facets__price-fill');
      this.minText = document.getElementById(this.dataset.minTarget);
      this.maxText = document.getElementById(this.dataset.maxTarget);

      if (!this.minThumb || !this.maxThumb || !this.fill) return;

      this.minThumb.addEventListener('input', this.onMinInput.bind(this));
      this.maxThumb.addEventListener('input', this.onMaxInput.bind(this));
      this.minThumb.addEventListener('change', this.onMinCommit.bind(this));
      this.maxThumb.addEventListener('change', this.onMaxCommit.bind(this));

      if (this.minText) this.minText.addEventListener('input', this.onMinTextInput.bind(this));
      if (this.maxText) this.maxText.addEventListener('input', this.onMaxTextInput.bind(this));

      this.paint();
    }

    paint() {
      var a = parseFloat(this.minThumb.value);
      var b = parseFloat(this.maxThumb.value);
      if (isNaN(a)) a = 0;
      if (isNaN(b)) b = this.rangeMax;
      var lo = Math.min(a, b);
      var hi = Math.max(a, b);
      if (!this.rangeMax) return;
      this.fill.style.left = (lo / this.rangeMax * 100) + '%';
      this.fill.style.right = (100 - hi / this.rangeMax * 100) + '%';
    }

    onMinInput() {
      if (parseFloat(this.minThumb.value) > parseFloat(this.maxThumb.value)) {
        this.minThumb.value = this.maxThumb.value;
      }
      if (this.minText) this.minText.value = this.minThumb.value;
      this.paint();
    }

    onMaxInput() {
      if (parseFloat(this.maxThumb.value) < parseFloat(this.minThumb.value)) {
        this.maxThumb.value = this.minThumb.value;
      }
      if (this.maxText) this.maxText.value = this.maxThumb.value;
      this.paint();
    }

    onMinCommit() {
      if (!this.minText) return;
      this.minText.value = this.minThumb.value;
      this.minText.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onMaxCommit() {
      if (!this.maxText) return;
      this.maxText.value = this.maxThumb.value;
      this.maxText.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onMinTextInput() {
      var v = parseFloat((this.minText.value || '').replace(',', '.'));
      if (!isNaN(v)) {
        this.minThumb.value = v;
        this.paint();
      }
    }

    onMaxTextInput() {
      var v = parseFloat((this.maxText.value || '').replace(',', '.'));
      if (!isNaN(v)) {
        this.maxThumb.value = v;
        this.paint();
      }
    }
  }

  customElements.define('price-range-slider', PriceRangeSlider);
})();